<template>
    <div class="equipment_library_wrap">
        <div class="header">
            <el-col :span="19">
                <el-button
                    type="default"
                    size="medium"
                    @click="$router.back()"
                >返回
                </el-button>
                <el-select
                    size="medium"
                    v-model="listQuery.equipType"
                    placeholder="请选择设备类型"
                    @change="getList"
                >
                    <el-option
                        :key="0"
                        label="全部"
                        :value="0"
                    ></el-option>
                    <el-option
                        v-for="item in typeList"
                        :key="item.code"
                        :label="item.value"
                        :value="item.code"
                    ></el-option>
                </el-select>
                <el-button
                    type="primary"
                    size="medium"
                    @click="exportUrl"
                >导出
                </el-button>
            </el-col>
        </div>
        <el-table
            stripe
            :data="dataList"
            :height="`${windowHeight - 210}px`"
            border
            style="width: 100%"
        >
            <el-table-column
                label="设备号"
                prop="equipmentId"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                label="所属学校"
                align="center"
                prop="schoolName"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                label="设备类型"
                align="center"
                prop="equipTypeName"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                label="型号"
                align="center"
                prop="moduleName"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                label="设备用途"
                align="center"
                prop="useTypeName"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                label="设备状态"
                align="center"
            >
                <template slot-scope="scope">
                  <span v-if="scope.row.state==2">
                    <el-tag
                        v-if="scope.row.status==2"
                        type="success" size="mini"
                    >在线</el-tag>
                    <el-tag
                        v-else-if="scope.row.status==1"
                        type="warning" size="mini"
                    >离线</el-tag>
                  </span>
                    <span v-else>
                        <el-tag type="danger" size="mini">未绑定</el-tag>
                      </span>
                </template>
            </el-table-column>

            <el-table-column
                label="创建时间"
                align="center"
            >
                <template slot-scope="scope">
                    <span>{{scope.row.createTime | timeFormat}}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            class="pagination-container"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.pageNo"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>

    </div>
</template>

<script>
    import {
        findDicsByCode,
        getEquipmentLibraryPage,
        delEquipmentLibrary,
    } from "@/api/equipmentLibrary";
    import windowResize from "@/mixins/windowResize";

    export default {
        data() {
            return {
                listQuery: {
                    pageNo: 1,
                    pageSize: 20,
                    equipType: 0,
                    equipmentId: "",
                    status: "0",
                    useType: 0,
                    moduleId: '',
                    schoolName: '',
                    schoolId: this.$route.query.schoolId
                },
                dataList: [],
                total: null,
                typeList: [],
            };
        },
        filters: {
            timeFormat(time) {
                return time ? time.substring(0, 19) : "--";
            },
        },
        created() {
            this.getList();
            this.findDicsByCodes();
        },
        activated() {
            this.getList();
            this.findDicsByCodes();
        },
        mixins: [windowResize],
        methods: {
            exportUrl() {
                const prefixUrl =
                    global.command === "production"
                        ? "https://www.zhxiaoyuan.cn/wxcepClient1/"
                        : "https://www.weixiaojia.net/wxcepClient1/";
                window.open(
                    `${prefixUrl}structure/scancodeEquipment/exportEquipmentLibrary?equipType=${this.listQuery.equipType}&equipmentId=&moduleId=&schoolId=${this.listQuery.schoolId}&status=0&useType=0&token=${this.$store.getters.token}`,
                    "_blank"
                );
            },
            findDicsByCodes() {
                findDicsByCode().then((res) => {
                    let data = res.data.data;
                    this.typeList = data;
                });
            },
            //获取列表
            getList() {
                getEquipmentLibraryPage(this.listQuery)
                    .then((res) => res.data)
                    .then((data) => {
                        this.dataList = data.data.dataList;
                        this.total = data.data.pagination.total;
                    })
                    .catch((err) => {
                    });
            },
            delEquipmentLibrary(form) {
                delEquipmentLibrary(form).then((res) => {
                    this.$message({
                        message: "删除成功",
                        type: "success",
                    });
                    this.getList();
                });
            },
            handleDelete(item) {
                this.$confirm("此操作将删除此设备, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.delEquipmentLibrary({
                            equipType: item.equipType,
                            equipmentId: item.equipmentId,
                        });

                    })
                    .catch(() => {
                    });
            },
            //搜索
            changeType() {
                this.listQuery.status = "0";
                this.subFindDicsByCode();
            },
            //搜索
            handleFilter() {
                this.listQuery.pageNo = 1;
                this.getList();
            },
            //切换码数
            handleSizeChange(val) {
                this.listQuery.pageNo = 1;
                this.listQuery.pageSize = val;
                this.getList();
            },
            //切换页数
            handleCurrentChange(val) {
                this.listQuery.pageNo = val;
                this.getList();
            },

            gotoAdd() {
                this.$router.push({
                    path: "form",
                });
            },
            gotoEdit(item) {
                this.$router.push({
                    path: "form",
                    query: {
                        scanId: item.id,
                    },
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .equipment_library_wrap {
        padding: 12px;

        .header {
            padding-bottom: 10px;
            overflow: hidden;
        }

        .el-select {
            width: 150px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/hardwareManage/deviceAccountingBySchool.vue